/**
 * Utility to determine if a video conversion is still pending.
 *
 * @param isConvertedInDb - The explicit isConverted flag from the database
 * @param hasMetadata - True if the content has associated metadata (typically from optimization)
 * @param fileName - The name of the file (used to check extension)
 * @param isPendingInSocket - True if the item is actively being tracked by UUID via websockets
 * @returns boolean True if the conversion is still pending, false otherwise
 */
export function isConversionPending(
    isConvertedInDb: boolean,
    hasMetadata: boolean,
    fileName: string = '',
    isPendingInSocket?: boolean,
): boolean {
    const unconvertedVideoFormat = fileName.includes('mp4');
    // We just check if the metadata.optimizeVideo has the value of true
    return isPendingInSocket || (!isConvertedInDb && hasMetadata && unconvertedVideoFormat);
}
